<template>
    <div v-bind:class="{ 'foodmash-card': true, 'foodmash-card-hidden': swiped || ($vnode.key > 2 + cardOffset) }"
         v-bind:style="{ 'transform': 'scale(' + (20 - $vnode.key + cardOffset) / 20 + ') translateY(-' + (30 * ($vnode.key - cardOffset)) + 'px)' }">
        <div class="foodmash-card-body">
            <img :src="image" alt="foodmash-card-image" loading="lazy"/>
            <a :href="restaurantLink" target="_blank" class="foodmash-title ellipsis-text">{{ restaurantName }}</a>
            <p class="ellipsis-text"><i class="lnr lnr-map-marker"></i> {{ restaurantAddress }}</p>
            <hr>
            <span v-for="(category, index) in categories" :key="index">
                <a rel="nofollow" :href="category.link" target="_blank">{{ category.name }}</a>
            </span>
        </div>
    </div>
</template>

<script>
import cardMixin from "../cardMixin";

export default {
    name: 'FoodmashCard',
    mixins: [cardMixin],
    props: {
        image: String,
        restaurantName: String,
        restaurantSlug: String,
        restaurantAddress: String,
        restaurantCity: String,
        restaurantCountry: String,
        restaurantCoordinates: String,
        restaurantCategories: Object | Array,
        swiped: Boolean,
        cardOffset: Number
    },
    data() {
        return {
            categories: []
        }
    },
    computed: {
        restaurantLink() {
            return `${this.getBaseUrl()}/restaurants/${this.restaurantCity}/${this.restaurantSlug}`;
        }
    },
    methods: {
        limitStringLength(str, maxLength) {
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + '...';
            } else {
                return str;
            }
        }
    },
    created() {
        let categoriesLimit = 3;
        if (window.screen.height <= 870) {
            categoriesLimit = 1;
        }

        for (let key in this.restaurantCategories) {
            if (this.categories.length >= categoriesLimit) {
                break;
            }

            if (this.restaurantCategories.hasOwnProperty(key)) {
                if (!this.restaurantCategories[key].hasOwnProperty('link')) {
                    let country = this.restaurantCountry.toLowerCase();
                    let citySlug = `${country}_${this.restaurantCity}&${this.restaurantCoordinates}`;
                    let categorySlug = this.restaurantCategories[key].slug;
                    this.restaurantCategories[key].link = `${this.getBaseUrl()}/search/restaurants/city/${citySlug}/terms/${categorySlug}`;
                }

                if (!this.restaurantCategories[key].name.startsWith("#")) {
                    this.restaurantCategories[key].name = "# " + this.restaurantCategories[key].name;
                }

                this.restaurantCategories[key].name = this.limitStringLength(this.restaurantCategories[key].name, 40);

                this.categories.push(this.restaurantCategories[key]);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FoodmashCard.vue